<template>
    <div class="col-12 col-md-5 col-xl-3 mb-4 mb-xl-0">
        <div class="focus d-flex flex-column bg-light p-0 mb-4 mb-sm-0">
            <img :src="focus.d_image"
                :alt="focus.d_imageAlt"
                class="cover">
            <div class="focusTitle position-relative">
            <p class="text-center text-uppercase theme px-3 py-1 m-0">• {{ focus.d_theme }} •</p>
            <p :class="classFocusTitle(focus.d_nomSociete)"
                class="text-left small-ls text-uppercase openSans-bold px-3 py-1 border-bottom m-0">
                {{ focus.d_titre }}
            </p>
            </div>
            <p class="content text-justify small-ls px-3 py-1 m-0" v-html="focus.d_texte.slice(0, 120) +'...'"></p>
            <router-link :to="{ name:focus.d_nomSociete + '_Focus', params: { focusRecordId: focus.recordId } }"
                        :class="focus.d_nomSociete"
                        class="readMore text-dark openSans-bold px-3 pt-1 pb-3 mt-auto"><u>En savoir plus</u></router-link>
        </div>
    </div>
</template>

<script>
export default {
  name: 'FocusPreview',
  props: {
    focus: Object
  },
  methods: {
    classFocusTitle (nomSociete) {
      switch (nomSociete) {
        case 'Tolus Immo': {
          return 'text-secondary border-secondary'
        }
        case 'CG Courtage': {
          return 'text-primary border-primary'
        }
        default:
          return 'text-dark'
      }
    }
  }
}
</script>

<style lang="scss">
.focus {
  height: 100%;
  width: 100%;
  img {
    width: 100% !important;
    height: 15rem !important;
  }
  .readMore.CG:hover {
    u {
      color: var(--primary) !important;
    }
  }
  .readMore.Tolus:hover {
    u {
      color: var(--secondary) !important;
    }
  }
  .content {
    height: 6rem !important;
    overflow: hidden;
  }
}
</style>
